import moment from 'moment';

import { FirstAvailableModel } from 'src/services/availability';

export function firstAvailableToNumber(a: FirstAvailableModel) {
    if (!a || !a.firstAvailable) {
        return Infinity;
    }
    return moment(`${a.firstAvailable.date} ${a.firstAvailable.time}`).valueOf();
}
